import type { Lang } from "@iyk/vf-app-config"
import * as React from "react"
import { translations } from "./translations.ts"

export const Terms = (props: Terms.Props) => {
  const t = translations[props.lang]

  const artist = props.artistPrivacyPolicy?.name || props.artistTermsOfService?.name

  return (
    <p className="text-xs text-gray-11 mt-3">
      {t.Terms.intro}{" "}
      <a href={props.privacyPolicyUrl} target="_blank" className="underline">
        {t.Terms.privacy()}
      </a>{" "}
      {t.Terms.and}{" "}
      <a href={props.termsOfServiceUrl} target="_blank" className="underline">
        {t.Terms.terms()}
      </a>
      {artist && (
        <React.Fragment>
          , {t.Terms.artistPrivacyPrefix} {artist}{" "}
          {props.artistPrivacyPolicy && (
            <a href={props.artistPrivacyPolicy.url} target="_blank" className="underline">
              {t.Terms.privacy()}
            </a>
          )}
          {props.artistPrivacyPolicy && props.artistTermsOfService && ` ${t.Terms.and} `}
          {props.artistTermsOfService && (
            <a href={props.artistTermsOfService.url} target="_blank" className="underline">
              {t.Terms.terms()}
            </a>
          )}
        </React.Fragment>
      )}
      .
    </p>
  )
}

namespace Terms {
  export type Props = {
    privacyPolicyUrl: string
    termsOfServiceUrl: string
    artistPrivacyPolicy?: {
      url: string
      name: string
    }
    artistTermsOfService?: {
      url: string
      name: string
    }
    lang: Lang
  }
}
